<template>
	<FormulateInput
		v-model="model"
		label-text="Поток*"
		type="CustomSearchSelect"
		name="formulate_product_id"
		:options="productsList"
		placeholder="Выберите значение"
		class=""
		validation="required"
		:validation-messages="{
			'required': 'выберите значение',
		}"
		@search="getProducts($event)"
	/>
</template>

<script>

export default {
	props: {
		context: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			model: null,
			productsList: [],
		};
	},
	async created() {
		await this.getProducts('');
	},
	methods: {
		async getProducts(search) {
			const { data: products } = await this.$api.getMultiselectProducts(search);
			this.productsList = products;
		},
	},
};
</script>

<style scoped lang="scss">
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.user-profile-dadata-input-label {
    font-weight: 500;
    line-height: 1.2;
	margin-bottom: 0.5rem;
}
</style>
<style lang="scss">
.user-profile-dadata-input {
	& .vs__input {
        border-radius: 0 !important;
        border: 1px solid #949ABA !important;
        font-size: 1rem !important;
        padding: 1.3rem 1rem 1.3rem 1rem !important;
        line-height: 1.5rem !important;
        height: calc(1.5em + 0.75rem + 2px);
        font-family: "Raleway", sans-serif;
        font-weight: 500;

        &::placeholder {
            font-weight: 300;
            color: #959BBA;
        }
    }
}
</style>
